window.addEventListener('scroll', () => {
  const logoText = document.querySelector('.logo-text');
  const navBar = document.querySelector('.l-site-nav');

  if (window.scrollY > 50) {
    logoText.classList.add('hidden');
    navBar.classList.add('bg-primary');
  } else {
    logoText.classList.remove('hidden');
    navBar.classList.remove('bg-primary');
  }
});
